import React, { useState, useEffect } from "react";
import "./sales.scss";
import DataTable from "./DataTable/DataTable";
import { Modal } from "react-bootstrap";
import { Api_Url } from "../../../utils/ApiUrl";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import moment from "moment";
import { useWeb3React } from "@web3-react/core";
import Environment from "../../../utils/Environment";
import { getdoproundcreatecontract } from "../../../utils/contractHelpers";
import { getinstitutionpresalecontract } from "../../../utils/contractHelpers";

import { getERC20Token } from "../../../utils/contractHelpers";
import Web3 from "web3";
import useWeb3 from "../../../hooks/useWeb3";
import Loader from "../../../hooks/loader";
import CuurentRound from "../../../hooks/dataFetchers/round";
import Timer from "../../../hooks/dataFetchers/timer";
import { difference } from "lodash";
import Multiselect from "multiselect-react-dropdown";

const SalesRound = ({ setindexwait }) => {
  const { account } = useWeb3React();
  //   console.log("account we get here is", account);
  const val = localStorage.getItem("accessToken");

  const tokensList = [
    { name: "ETH", address: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE" },
    { name: "USDT", address: "0xdAC17F958D2ee523a2206206994597C13D831ec7" },
    { name: "TOMI", address: "0x4385328cc4D643Ca98DfEA734360C0F596C83449" },
  ];

  const [selectedTokensList, setSelectedTokensList] = useState([]);
  const [selectedTokensListInstitution, setSelectedTokensListInstitution] =
    useState([]);

  const [ownerAddress, setOwnerAddress] = useState("");

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => {
    setErrors({});
    setName(null);
    setPrice(null);
    setStart(null);
    setEndDate(null);
    setShow1(false);
  };
  const { cuurentRound } = CuurentRound();
  const { timer } = Timer();
  const [currentRoundd, setCurrentRoundd] = useState(1);
  const [currentRoundPrice, setCurrentRoundPrice] = useState(0);

  const [round, setRound] = useState(1);
  const [show11, setShow11] = useState(false);
  const [show33, setShow33] = useState(false);
  const [show44, setShow44] = useState(false);

  const handleClose11 = () => {
    setErrors({});
    setEndDate();
    setStart();
    setPrice();
    seteditval();
    setShow11(false);
  };

  const handleClose33 = () => {
    setSelectedTokensList([]);
    setErrors({});
    setShow33(false);
  };

  const handleClose44 = () => {
    setSelectedTokensListInstitution([]);
    // setErrors({});
    setShow44(false);
  };

  const handleShow33 = () => {
    getTokenData();
    setShow33(true);
  };

  const handleShow44 = () => {
    getTokenData();
    setShow44(true);
  };
  const [show22, setShow22] = useState(false);
  const handleClose22 = () => setShow22(false);
  const [editval, seteditval] = useState();
  const [tokenData, setTokenData] = useState([]);

  const [loaderr, setLoarder] = useState(false);
  const handleClose111 = () => setShow111(false);
  const [show111, setShow111] = useState(false);
  const tok = localStorage?.getItem("accessToken");
  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const [Name, setName] = useState(null);
  const [Price, setPrice] = useState(null);
  const [Start, setStart] = useState(null);
  const [EndDate, setEndDate] = useState(null);
  const [discount, setDiscount] = useState([]);

  // const [TotalAlloc, setTotalAlloc] = useState(null)
  // const [DOPpur, setDOPpur] = useState(null)
  const [userDel, setUserDel] = useState(null);
  // console.log("delete", userDel)
  const [showError, setError] = useState("");
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const history = useHistory();
  const web3 = useWeb3();
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);
  const [pages, setPages] = useState([]);
  const [rend, setRend] = useState(false);
  const [limit, setLimit] = useState(1);
  const [allRounds, setAllRounds] = useState([]);
  const [roundToggleBool, setRoundToggleBool] = useState(false);
  const [discountBoolYes, setDiscountBoolYes] = useState([]);
  const [discountBoolNo, setDiscountBoolNo] = useState([]);
  const [roundTokens, setRoundTokens] = useState([]);

  const [show3, setShow3] = useState(false);
  const handleClose3 = () => setShow3(false);

  const tokenSymbolFromContract = async (value) => {
    const contract = getERC20Token(value, web3);
    const symbol = await contract.methods.symbol().call();
    return symbol;
  };

  const getTokenData = async () => {
    var config = {
      method: "get",
      url: `${Api_Url}/tokens/minimal?limit=50`,

      headers: {
        Authorization: "Bearer " + val,
      },
    };

    axios(config)
      .then(function (res) {
        setTokenData(res?.data?.data);

        setLoader(false);
      })
      .catch(function (error) {
        setLoader(false);
      });
  };
  const roundTokenData = async (e) => {
    var data = JSON.stringify({
      query: `query MyQuery {  
        tokensAccessUpdateds(where: {round: ${e}})
                {
                  token
    round
    id
    transactionHash
    access
    customPrice
              }
                      }`,
      variables: {},
      // https://api.studio.thegraph.com/query/51954/dopmain/version/latest
    });

    var config1 = {
      method: "post",
      url: Environment.graph,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    await axios(config1)
      .then(async (response) => {
        let responseData = response?.data?.data?.tokensAccessUpdateds;

        let discountPrice = responseData?.map((item) => {
          return item?.customPrice / 10 ** 18;
        });

        setDiscount(discountPrice);
        let discountBoolArrYes = responseData?.map((item) => {
          if (item?.customPrice > 0) {
            return true;
          } else {
            return false;
          }
        });
        let discountBoolArrNo = responseData?.map((item) => {
          if (item?.customPrice > 0) {
            return false;
          } else {
            return true;
          }
        });
        setDiscountBoolYes(discountBoolArrYes);
        setDiscountBoolNo(discountBoolArrNo);

        const newData = await Promise.all(
          responseData.map(async (item) => {
            let symbol;
            if (item.token) {
              if (item.token == "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE") {
                symbol = "ETH";
              } else {
                try {
                  const symbolValue = await tokenSymbolFromContract(item.token);
                  symbol = symbolValue || "N/A";
                } catch (error) {
                  console.error("Error fetching symbol:", error);
                  symbol = "N/A";
                }
              }
            } else {
              // Handle the case where the "token" value is not available
              symbol = "N/A";
            }

            // Return the updated object
            return {
              ...item,
              symbol,
            };
          })
        );
        setSelectedTokensList(newData);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const roundTokenDataInstitution = async (e) => {
    var data = JSON.stringify({
      query: `query MyQuery {  
        tokensAccessUpdateds
                {
                  token
    id
    transactionHash
    access
    
              }
                      }`,
      variables: {},
      // https://api.studio.thegraph.com/query/51954/dopmain/version/latest
    });

    var configInst = {
      method: "post",
      url: Environment.institutionGraph,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    await axios(configInst)
      .then(async (response) => {
        let responseData = response?.data?.data?.tokensAccessUpdateds;

        const newData = await Promise.all(
          responseData.map(async (item) => {
            let symbol;
            if (item.token) {
              if (item.token == "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE") {
                symbol = "ETH";
              } else {
                try {
                  const symbolValue = await tokenSymbolFromContract(item.token);
                  symbol = symbolValue || "N/A";
                } catch (error) {
                  console.error("Error fetching symbol:", error);
                  symbol = "N/A";
                }
              }
            } else {
              // Handle the case where the "token" value is not available
              symbol = "N/A";
            }

            // Return the updated object
            return {
              ...item,
              symbol,
            };
          })
        );
        setSelectedTokensListInstitution(newData);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const CreateRound = async () => {
    const tok = localStorage?.getItem("accessToken");
    if (ValidateForm()) {
      const price = Web3.utils.toWei(Price, "ether");
      const startTime = new Date(Start).getTime() / 1000;
      const endTime = new Date(EndDate).getTime() / 1000;
      setLoader(true);
      try {
        handleClose1();
        // setOpens(true);
        setLoarder(true);
        const contract = getdoproundcreatecontract(
          Environment.DOPRoundSingleContract,
          web3
        );
        // let gasPrice = await web3.eth.getGasPrice()
        // gasPrice = parseInt(gasPrice) + 3000000000
        // const gas = await contract.methods
        //     .createNewRound(startTime, endTime, price)
        //     .estimateGas({
        //         from: account,
        //     });
        const addressesOnly = selectedTokensList.map((token) => token.address);
        const addressesAccess = selectedTokensList.map((token) => true);

        const createround = await contract.methods
          .createNewRound(
            startTime,
            endTime,
            price
            // addressesOnly,
            // addressesAccess
          )
          .send({ from: account })
          .on("transactionHash", (tx) => {
            return tx.transactionHash;
          });
        if (createround) {
          CreateeNewRoundAPI();
          Getroundsdata();
          roundData();
          firstTimeData();
          setLoarder(false);
        }
        Getroundsdata();
        // return approved;
      } catch (err) {
        handleClose1();
        setLoarder(false);
        setLoader(false);
        console.log("round err", err);
        throw err;
      }
    }
  };

  const CreateeNewRoundAPI = async () => {
    // if (account) {
    var config = {
      method: "post",
      url: `${Api_Url}/sale-rounds`,
      headers: {
        authorization: `Bearer ` + tok,
      },
      data: {
        nickName: Name,
        salePrice: Price,
        startDate: Start,
        endDate: EndDate,
      },
    };

    axios(config)
      .then(function (response) {
        // setLoader(false);
        // window.scrollTo(0, 0);
      })
      .catch(function (error) {
        console.log(error);
        // setLoader(false);
      });
    // }
  };

  const Getroundsdata = async (e) => {
    var data = JSON.stringify({
      query: `query MyQuery {  
        roundCreateds
            (
                first: 10
                orderBy: blockTimestamp
                orderDirection: desc
                ) 
                {
                  roundData_endTime
                  roundData_price
                  roundData_startTime
                  newRound
                id
              }
            
                      }`,
      variables: {},
      // https://api.studio.thegraph.com/query/51954/dopmain/version/latest
    });
    var data1 = JSON.stringify({
      query: `query MyQuery {  
        roundCreateds
            (
                first: 16
                orderBy: blockTimestamp
                orderDirection: desc
                ) 
                {
                  roundData_endTime
                  roundData_price
                  roundData_startTime
                  newRound
                id
              }
              tokensAccessUpdateds {
                access
                blockTimestamp
                customPrice
                round
                token
              }
                      }`,
      variables: {},
      // https://api.studio.thegraph.com/query/51954/dopmain/version/latest
    });
    var config = {
      method: "post",
      url: "https://api.studio.thegraph.com/query/51954/dopgraphcombined/version/latest",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    var config1 = {
      method: "post",
      url: Environment.graph,
      headers: {
        "Content-Type": "application/json",
      },
      data: data1,
    };
    let dataGraph = [];
    let dataGraph1 = [];

    await axios(config)
      .then((response) => {
        dataGraph = [...response?.data?.data?.roundCreateds];
        dataGraph.reverse();
        // setAllRounds(response?.data?.data?.roundCreateds);
      })
      .catch((err) => {
        console.log(err);
      });
    await axios(config1)
      .then(async (response) => {
        let responseData = response?.data?.data?.tokensAccessUpdateds;

        const newData = await Promise.all(
          responseData.map(async (item) => {
            let symbol;
            if (item.token) {
              try {
                const symbolValue = await tokenSymbolFromContract(item.token);
                symbol = symbolValue || "N/A";
              } catch (error) {
                console.error("Error fetching symbol:", error);
                symbol = "N/A";
              }
            } else {
              // Handle the case where the "token" value is not available
              symbol = "N/A";
            }

            // Return the updated object
            return {
              ...item,
              symbol,
            };
          })
        );

        const groupedData = newData.reduce((acc, item) => {
          const round = item.round;

          // If the round doesn't exist in the accumulator, create an array for it
          if (!acc[round]) {
            acc[round] = [];
          }

          // Push the item to the array corresponding to its round
          acc[round].push(item);

          return acc;
        }, {});

        // Convert the grouped data back to an array of objects
        // const arrangedData = Object.entries(groupedData).map(
        //   ([round, items]) => ({
        //     round,
        //     items,
        //   })
        // );
        setRoundTokens(groupedData);

        dataGraph1 = [
          ...dataGraph,
          ...response?.data?.data?.roundCreateds.reverse(),
        ];
      })
      .catch((err) => {
        console.log(err);
      });
    setAllRounds(dataGraph1);
  };
  const ValidateForm = () => {
    // console.log("validationssss");
    // let input = userInput;
    let errors = {};
    let isValid = true;

    if (!Name) {
      isValid = false;
      errors["name"] = "*Please enter Round Number";
    }

    if (!Price) {
      isValid = false;
      errors["price"] = "*Please enter a Sale Price";
    }

    if (!Start) {
      isValid = false;
      errors["start"] = "*Please enter a start Date";
    }

    if (!EndDate) {
      isValid = false;
      errors["enddate"] = "*Please enter a End Date";
    }

    // if (selectedTokensList?.length == 0) {
    //   isValid = false;
    //   errors["tokens"] = "*Please select a Token";
    // }

    // if (!DOPpur) {
    //     isValid = false;
    //     errors["doppur"] = "*Please enter a DOP Purchased";
    // }

    setErrors(errors);
    return isValid;
  };

  const ValidateFormEdit = () => {
    // console.log("validationssss");
    // let input = userInput;
    let errors = {};
    let isValid = true;
    const formattedStartTime = moment
      .unix(editval?.roundData_startTime)
      .format("YYYY-MM-DDTHH:mm");
    const formattedEndTime = moment
      .unix(editval?.roundData_endTime)
      .format("YYYY-MM-DDTHH:mm");

    if (
      Price &&
      Price == editval?.roundData_price / 10 ** 18 &&
      EndDate == formattedEndTime
    ) {
      isValid = false;
      errors["price"] = "*Please enter a Sale Price";
    } else if (!Price) {
      isValid = false;
      errors["price"] = "*Please enter a Sale Price";
    }

    if (!Start) {
      isValid = false;
      errors["start"] = "*Please enter a Start Date";
    }

    if (
      EndDate &&
      Price == editval?.roundData_price / 10 ** 18 &&
      EndDate == formattedEndTime
    ) {
      isValid = false;
      errors["enddate"] = "*Please enter an End Date";
    } else if (!EndDate) {
      isValid = false;
      errors["enddate"] = "*Please enter an End Date";
    }

    // if (!DOPpur) {
    //     isValid = false;
    //     errors["doppur"] = "*Please enter a DOP Purchased";
    // }

    setErrors(errors);
    return isValid;
  };

  const DeleteUser = async () => {
    // console.log("user delete", userDel?.newRound);
    try {
      handleClose111();
      setLoarder(true);
      // setOpens(true);
      const contract = getdoproundcreatecontract(
        Environment.DOPRoundSingleContract,
        web3
      );
      let gasPrice = await web3.eth.getGasPrice();
      gasPrice = parseInt(gasPrice) + 3000000000;
      const gas = await contract.methods
        .deleteRound(userDel?.newRound)
        .estimateGas({
          from: account,
        });
      const createround = await contract.methods
        .deleteRound(userDel?.newRound)
        .send({ from: account, gas: gas, gasPrice })
        .on("transactionHash", (tx) => {
          return tx.transactionHash;
        });
      if (createround) {
        Getroundsdata();
        setLoarder(false);
      }
      Getroundsdata();
      // return approved;
    } catch (err) {
      handleClose111();
      setLoarder(false);
      console.log("round err", err);
      throw err;
    }
  };

  const roundToggle = async (e) => {
    try {
      handleClose3();
      setLoarder(true);
      // setOpens(true);
      const contract = getdoproundcreatecontract(
        Environment.DOPRoundSingleContract,
        web3
      );
      //   let gasPrice = await web3.eth.getGasPrice();
      //   gasPrice = parseInt(gasPrice) + 3000000000;
      //   const gas = await contract.methods
      //     .deleteRound(userDel?.newRound)
      //     .estimateGas({
      //       from: account,
      //     });
      const toggleRound = await contract.methods
        .enableBuy(e.target.checked)
        // .send({ from: account, gas: gas, gasPrice })
        .send({ from: account })
        .on("transactionHash", (tx) => {
          return tx.transactionHash;
        });
      if (toggleRound) {
        callRound();
        setLoarder(false);
      }
      callRound();
      // return approved;
    } catch (err) {
      handleClose3();
      setLoarder(false);
      console.log("round err", err);
      throw err;
    }
  };

  const callRound = async () => {
    try {
      //   setLoarder(true);
      // setOpens(true);
      const contract = getdoproundcreatecontract(
        Environment.DOPRoundSingleContract,
        web3
      );
      //   let gasPrice = await web3.eth.getGasPrice();
      //   gasPrice = parseInt(gasPrice) + 3000000000;
      //   const gas = await contract.methods
      //     .deleteRound(userDel?.newRound)
      //     .estimateGas({
      //       from: account,
      //     });
      const toggleRound = await contract.methods
        .buyEnable()
        // .send({ from: account, gas: gas, gasPrice })
        .call();

      if (toggleRound) {
        setRoundToggleBool(toggleRound);
        // console.log("round:", toggleRound);
        // Getroundsdata();
        // setLoarder(false);
      }
      //   Getroundsdata();
      // return approved;
    } catch (err) {
      //   handleClose3();
      //   setLoarder(false);
      console.log("round err", err);
      throw err;
    }
  };

  const GetAllRounds = async (off) => {
    let valu = null;
    if (off) {
      valu = off;
    } else {
      valu = 1;
    }
    // if (account) {
    var config = {
      method: "get",
      url: `${Api_Url}/sale-rounds?offset=${valu}&&limit=5`,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };

    axios(config)
      .then(function (response) {
        // setLoader(false);
        setCount(response.data.data.count);
        setAllRounds(response.data.data.saleRounds);
        let arr = Array.from(Array(parseInt(response.data.data.pages)).keys());
        setPages(arr);
        setCurrentPage(valu);
        // setSearch('')
        if (off <= response.data.data.squad.length) {
          if (off - 1 == 0) {
            setLimit(1);
          } else {
            setLimit((off - 1) * 5);
          }
        }
        // window.scrollTo(0, 0);
      })
      .catch(function (error) {
        console.log(error);
        // setLoader(false);
      });
    // }
  };

  const getPrevData = (off) => {
    let offset = parseInt(off) - 1;
    if (offset > 0) {
      // setLoader(true);
      var config = null;
      config = {
        method: "get",
        url: `${Api_Url}/sale-rounds?offset=${offset}&&limit=5`,
        headers: {
          Authorization: "Bearer " + tok,
          "Content-Type": "application/json",
        },
      };

      axios(config)
        .then(function (response) {
          let arr = Array.from(
            Array(parseInt(response.data.data.pages)).keys()
          );
          setPages(arr);
          setAllRounds(response.data.data.saleRounds);
          if (currentPage - 1 >= 0) {
            setCurrentPage(currentPage - 1);
          }
          if (off >= 0) {
            if (offset - 1 == 0) {
              setLimit(1);
            } else {
              setLimit((offset - 1) * 5);
            }
          }
          // else{
          //   setLimit(off)
          // }
          setRend(!rend);
        })
        .catch(function (error) {
          console.log(error);
        });
      // setLoader(false);
    }
  };

  const getNextData = (off) => {
    let offset = parseInt(off) + 1;
    if (pages.length > off) {
      if (off < allRounds.length) {
        var config = null;
        config = {
          method: "get",
          url: `${Api_Url}/sale-rounds?offset=${offset}&&limit=5`,
          headers: {
            Authorization: "Bearer " + tok,
            "Content-Type": "application/json",
          },
        };
        axios(config)
          .then(function (response) {
            // console.log(response.data.data);
            let arr = Array.from(
              Array(parseInt(response.data.data.pages)).keys()
            );
            setPages(arr);
            setAllRounds(response.data.data.saleRounds);
            if (off <= allRounds.length) {
              setCurrentPage(offset);
              setLimit(off * 5);
            }
            setRend(!rend);
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    }
  };

  const getOwnerAddress = async () => {
    const contract = getdoproundcreatecontract(
      Environment.DOPRoundSingleContract,
      web3
    );
    //   let gasPrice = await web3.eth.getGasPrice();
    //   gasPrice = parseInt(gasPrice) + 3000000000;
    //   const gas = await contract.methods
    //     .deleteRound(userDel?.newRound)
    //     .estimateGas({
    //       from: account,
    //     });
    const ownerAddressTemp = await contract.methods
      .owner()
      .call({ from: account });
    if (ownerAddressTemp) {
      setOwnerAddress(ownerAddressTemp);
    }
  };
  useEffect(() => {
    callRound();
    Getroundsdata();
    getOwnerAddress();
    // getTokenData();
  }, []);
  useEffect(() => {
    if (editval) {
      setPrice(editval?.roundData_price / 10 ** 18);
      const formattedStartTime = moment
        .unix(editval?.roundData_startTime)
        .format("YYYY-MM-DDTHH:mm");
      const formattedEndTime = moment
        .unix(editval?.roundData_endTime)
        .format("YYYY-MM-DDTHH:mm");
      setStart(formattedStartTime);
      setEndDate(formattedEndTime);
    }
  }, [editval]);

  const functiontogetback = () => {
    localStorage.setItem("indexvalue", 0);
    setindexwait(0);
  };

  const connectwalletfirst = () => {
    toast.error("Please connect your wallet first ", {
      position: "top-right",
      autoClose: 3000,
    });
  };
  const ownerWalletAddressMessage = () => {
    toast.error("This Wallet Address is not authorized for this", {
      position: "top-right",
      autoClose: 3000,
    });
  };
  const roundnotbecreated = () => {
    toast.error(
      "Please wait until already running round will complete then try again",
      {
        position: "top-right",
        autoClose: 3000,
      }
    );
  };

  const EditRound = async () => {
    if (ValidateFormEdit()) {
      const price = Web3.utils.toWei(Price.toString(), "ether");
      const startTime = new Date(Start).getTime() / 1000;
      const endTime = new Date(EndDate).getTime() / 1000;
      setLoader(true);
      try {
        setLoarder(true);
        const contract = getdoproundcreatecontract(
          Environment.DOPRoundSingleContract,
          web3
        );
        const createround = await contract.methods
          .updateRound(editval?.newRound.toString(), startTime, endTime, price)
          .send({ from: account })
          .on("transactionHash", (tx) => {
            return tx.transactionHash;
          });

        if (createround) {
          Getroundsdata();
          setLoarder(false);
          handleClose11();
          setShow22(true);
          seteditval();
        }
        Getroundsdata();
      } catch (err) {
        setLoarder(false);
        setLoader(false);
        console.log("round err", err);
        throw err;
      }
    }
  };

  const editDiscount = async () => {
    setLoader(true);
    try {
      setLoarder(true);
      const contract = getdoproundcreatecontract(
        Environment.DOPRoundSingleContract,
        web3
      );

      if (selectedTokensList?.length > 0) {
        const addressesOnly = selectedTokensList?.map((token) => {
          return token?.token;
        });
        const addressesAccess = selectedTokensList?.map(
          (token) => token?.access
        );

        let newDiscountArray = [...discount];

        if (discount?.length < selectedTokensList?.length) {
          newDiscountArray = Array(selectedTokensList?.length).fill(0);
        }

        const discountedPrice = selectedTokensList?.map((token, index) => {
          let value = newDiscountArray[index];

          // Check if the value is null, empty string, or undefined and replace it with 0
          if (value === null || value === "" || value === undefined) {
            value = 0;
          }

          return Web3.utils.toWei(value.toString(), "ether");
        });

        const editround = await contract.methods
          .updateAllowedTokens(
            editval?.newRound.toString(),
            addressesOnly,
            addressesAccess,
            discountedPrice
          )
          .send({ from: account })
          .on("transactionHash", (tx) => {
            return tx.transactionHash;
          });
        if (editround) {
          Getroundsdata();
          setLoarder(false);
          handleClose33();
          setShow22(true);
        }
      }

      Getroundsdata();
    } catch (err) {
      setLoarder(false);
      setLoader(false);
      console.log("round err", err);
      throw err;
    }
  };

  const allowTokensInstitution = async () => {
    setLoader(true);
    try {
      setLoarder(true);
      const contract = getinstitutionpresalecontract(
        Environment.InstitutionPreSale,
        web3
      );

      if (selectedTokensListInstitution?.length > 0) {
        const addressesOnly = selectedTokensListInstitution?.map((token) => {
          return token?.token;
        });
        const addressesAccess = selectedTokensListInstitution?.map(
          (token) => token?.access
        );

        const editround = await contract.methods
          .updateAllowedTokens(addressesOnly, addressesAccess)
          .send({ from: account })
          .on("transactionHash", (tx) => {
            return tx.transactionHash;
          });
        if (editround) {
          Getroundsdata();
          setLoarder(false);
          handleClose44();
          setShow22(true);
        }
      }

      Getroundsdata();
    } catch (err) {
      setLoarder(false);
      setLoader(false);
      console.log("round err", err);
      throw err;
    }
  };

  const firstTimeData = async () => {
    try {
      let b = await cuurentRound();
      // console.log("round data", b)
      if (b) {
        // console.log(b, 'noooor');
        // setCurrentRoundd(b)
        roundData(b);
        // const result = [];
        // for (let i = 1; i <= b; i++) {
        //   result.push(i);
        // }
        // setTotalRound(result);
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  const roundData = async (e) => {
    try {
      if (parseInt(e) <= 1) {
        // console.log('in if noor ', e);
        let c = await timer(e);
        if (c) {
          // console.log(c, 'ccc', c?.price / 10 ** 18);
          setCurrentRoundd(e);
          setCurrentRoundPrice(c?.price / 10 ** 18);
          setRound(e);
          // setPrice(c.price/10**18)
          // console.log('nooor',c.price);
          // setCurrentTimer(c)
        }
      } else {
        let dummy = [];
        for (let a = 1; a <= e; a++) {
          // console.log(a, 'loooop');
          let c = await timer(a);
          dummy.push(c);
        }
        calucation(dummy);
      }
    } catch (err) {
      console.log(err, "erro in timer");
    }
  };

  const calucation = (e) => {
    // console.log("dummy calculation", e)
    let dummy = [];
    let a = "";
    let indexx = "";
    let aaa = e.map((i, index) => {
      let tempLockedLending2 = "";
      if (
        currentTime > parseInt(i.startTime) &&
        currentTime < parseInt(i.endTime)
      ) {
        a = i;
        indexx = index + 1;
        let deff = currentTime - parseInt(i.startTime);
        tempLockedLending2 = { ...i, diffrence: deff, currentround: index + 1 };
        dummy.push(tempLockedLending2);
      } else {
        let deff = currentTime - parseInt(i.startTime);
        tempLockedLending2 = { ...i, diffrence: deff, currentround: index + 1 };
        dummy.push(tempLockedLending2);
      }
    });
    if (a) {
      // console.log('in if ', a);
      // setPrice(a?.price / 10 ** 18)
      // setCurrentRount(a)
      setCurrentRoundd(a?.endTime);
      setCurrentRoundPrice(a?.price / 10 ** 18);

      setRound(indexx);
      // setPrice(value?.price/10**18)
    } else if (dummy?.length > 0) {
      dummy.sort((a, b) => {
        return a?.diffrence - b?.diffrence;
      });
      // console.log(dummy[0], 'in else');
      // setCurrentRount(dummy[0])
      setCurrentRoundd(dummy[0]?.endTime);
      setCurrentRoundPrice(dummy[0]?.price / 10 ** 18);

      // console.log("value we have here is one ton", dummy[0]?.endTime )
      setRound(dummy[0]?.currentround);
      // setPrice(dummy[0]?.price / 10 ** 18)
    }
  };

  // console.log('new dateee', currentRoundd, round);

  useEffect(() => {
    roundData();
    firstTimeData();
  }, []);

  var now11 = new Date();
  let createdDate = now11?.getTime();
  // console.log(createdDate,'createdDate');
  let currentTime = createdDate / 1000;
  currentTime = parseInt(currentTime);

  return (
    <>
      {loaderr && <Loader />}
      <section className="salesround">
        <div className="custom-container">
          <button
            class="btn-back guvxgyvxvtxx"
            onClick={() => functiontogetback()}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
            >
              <path
                d="M8.37376 16.4675C8.20751 16.4675 8.04126 16.4062 7.91001 16.275L2.59876 10.9637C2.34501 10.71 2.34501 10.29 2.59876 10.0362L7.91001 4.72498C8.16376 4.47123 8.58376 4.47123 8.83751 4.72498C9.09126 4.97873 9.09126 5.39873 8.83751 5.65248L3.99001 10.5L8.83751 15.3475C9.09126 15.6012 9.09126 16.0212 8.83751 16.275C8.71501 16.4062 8.54001 16.4675 8.37376 16.4675Z"
                fill="white"
              ></path>
              <path
                d="M17.9375 11.1562H3.21124C2.85249 11.1562 2.55499 10.8587 2.55499 10.5C2.55499 10.1413 2.85249 9.84375 3.21124 9.84375H17.9375C18.2962 9.84375 18.5937 10.1413 18.5937 10.5C18.5937 10.8587 18.2962 11.1562 17.9375 11.1562Z"
                fill="white"
              ></path>
            </svg>{" "}
            Back
          </button>

          <div className="main-heading">
            <h6>Sale Rounds</h6>
            <div className="parent-btns">
              {account && account !== ownerAddress ? (
                <button
                  className="asasdasdasdasdasdasdds ijijijijij"
                  onClick={() => ownerWalletAddressMessage()}
                >
                  Create DOP Round
                </button>
              ) : account && account == ownerAddress ? (
                <button
                  className="asasdasdasdasdasdasdds"
                  onClick={() => setShow1(true)}
                >
                  Create DOP Round
                </button>
              ) : // : account && currentTime < currentRoundd ? (
              //   <button
              //     className="asasdasdasdasdasdasdds ijijijijij"
              //     onClick={() => roundnotbecreated()}
              //   >
              //     Create DOP Round
              //   </button>
              // )

              account == undefined || account == null || account == " " ? (
                <button
                  className="asasdasdasdasdasdasdds ijijijijij"
                  onClick={() => connectwalletfirst()}
                >
                  Create DOP Round
                </button>
              ) : (
                ""
              )}

              {account ? (
                <a className="round-setting " onClick={() => setShow3(true)}>
                  Round Settings{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M9.2502 22L8.8502 18.8C8.63353 18.7167 8.4292 18.6167 8.2372 18.5C8.0452 18.3833 7.85786 18.2583 7.6752 18.125L4.7002 19.375L1.9502 14.625L4.5252 12.675C4.50853 12.5583 4.5002 12.4457 4.5002 12.337V11.663C4.5002 11.5543 4.50853 11.4417 4.5252 11.325L1.9502 9.375L4.7002 4.625L7.6752 5.875C7.85853 5.74167 8.0502 5.61667 8.2502 5.5C8.4502 5.38333 8.6502 5.28333 8.8502 5.2L9.2502 2H14.7502L15.1502 5.2C15.3669 5.28333 15.5712 5.38333 15.7632 5.5C15.9552 5.61667 16.1425 5.74167 16.3252 5.875L19.3002 4.625L22.0502 9.375L19.4752 11.325C19.4919 11.4417 19.5002 11.5543 19.5002 11.663V12.337C19.5002 12.4457 19.4835 12.5583 19.4502 12.675L22.0252 14.625L19.2752 19.375L16.3252 18.125C16.1419 18.2583 15.9502 18.3833 15.7502 18.5C15.5502 18.6167 15.3502 18.7167 15.1502 18.8L14.7502 22H9.2502ZM12.0502 15.5C13.0169 15.5 13.8419 15.1583 14.5252 14.475C15.2085 13.7917 15.5502 12.9667 15.5502 12C15.5502 11.0333 15.2085 10.2083 14.5252 9.525C13.8419 8.84167 13.0169 8.5 12.0502 8.5C11.0669 8.5 10.2375 8.84167 9.5622 9.525C8.88686 10.2083 8.54953 11.0333 8.5502 12C8.5502 12.9667 8.88753 13.7917 9.5622 14.475C10.2369 15.1583 11.0662 15.5 12.0502 15.5ZM12.0502 13.5C11.6335 13.5 11.2792 13.354 10.9872 13.062C10.6952 12.77 10.5495 12.416 10.5502 12C10.5502 11.5833 10.6962 11.229 10.9882 10.937C11.2802 10.645 11.6342 10.4993 12.0502 10.5C12.4669 10.5 12.8212 10.646 13.1132 10.938C13.4052 11.23 13.5509 11.584 13.5502 12C13.5502 12.4167 13.4042 12.771 13.1122 13.063C12.8202 13.355 12.4662 13.5007 12.0502 13.5ZM11.0002 20H12.9752L13.3252 17.35C13.8419 17.2167 14.3212 17.0207 14.7632 16.762C15.2052 16.5033 15.6092 16.191 15.9752 15.825L18.4502 16.85L19.4252 15.15L17.2752 13.525C17.3585 13.2917 17.4169 13.046 17.4502 12.788C17.4835 12.53 17.5002 12.2673 17.5002 12C17.5002 11.7333 17.4835 11.471 17.4502 11.213C17.4169 10.955 17.3585 10.709 17.2752 10.475L19.4252 8.85L18.4502 7.15L15.9752 8.2C15.6085 7.81667 15.2045 7.496 14.7632 7.238C14.3219 6.98 13.8425 6.784 13.3252 6.65L13.0002 4H11.0252L10.6752 6.65C10.1585 6.78333 9.67953 6.97933 9.2382 7.238C8.79686 7.49667 8.39253 7.809 8.0252 8.175L5.5502 7.15L4.5752 8.85L6.72519 10.45C6.64186 10.7 6.58353 10.95 6.5502 11.2C6.51686 11.45 6.5002 11.7167 6.5002 12C6.5002 12.2667 6.51686 12.525 6.5502 12.775C6.58353 13.025 6.64186 13.275 6.72519 13.525L4.5752 15.15L5.5502 16.85L8.0252 15.8C8.39186 16.1833 8.7962 16.5043 9.2382 16.763C9.6802 17.0217 10.1592 17.2173 10.6752 17.35L11.0002 20Z"
                      fill="white"
                    />
                  </svg>
                </a>
              ) : (
                <a
                  className="round-setting ijijijijij"
                  onClick={() => connectwalletfirst()}
                >
                  Round Settings{" "}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M9.2502 22L8.8502 18.8C8.63353 18.7167 8.4292 18.6167 8.2372 18.5C8.0452 18.3833 7.85786 18.2583 7.6752 18.125L4.7002 19.375L1.9502 14.625L4.5252 12.675C4.50853 12.5583 4.5002 12.4457 4.5002 12.337V11.663C4.5002 11.5543 4.50853 11.4417 4.5252 11.325L1.9502 9.375L4.7002 4.625L7.6752 5.875C7.85853 5.74167 8.0502 5.61667 8.2502 5.5C8.4502 5.38333 8.6502 5.28333 8.8502 5.2L9.2502 2H14.7502L15.1502 5.2C15.3669 5.28333 15.5712 5.38333 15.7632 5.5C15.9552 5.61667 16.1425 5.74167 16.3252 5.875L19.3002 4.625L22.0502 9.375L19.4752 11.325C19.4919 11.4417 19.5002 11.5543 19.5002 11.663V12.337C19.5002 12.4457 19.4835 12.5583 19.4502 12.675L22.0252 14.625L19.2752 19.375L16.3252 18.125C16.1419 18.2583 15.9502 18.3833 15.7502 18.5C15.5502 18.6167 15.3502 18.7167 15.1502 18.8L14.7502 22H9.2502ZM12.0502 15.5C13.0169 15.5 13.8419 15.1583 14.5252 14.475C15.2085 13.7917 15.5502 12.9667 15.5502 12C15.5502 11.0333 15.2085 10.2083 14.5252 9.525C13.8419 8.84167 13.0169 8.5 12.0502 8.5C11.0669 8.5 10.2375 8.84167 9.5622 9.525C8.88686 10.2083 8.54953 11.0333 8.5502 12C8.5502 12.9667 8.88753 13.7917 9.5622 14.475C10.2369 15.1583 11.0662 15.5 12.0502 15.5ZM12.0502 13.5C11.6335 13.5 11.2792 13.354 10.9872 13.062C10.6952 12.77 10.5495 12.416 10.5502 12C10.5502 11.5833 10.6962 11.229 10.9882 10.937C11.2802 10.645 11.6342 10.4993 12.0502 10.5C12.4669 10.5 12.8212 10.646 13.1132 10.938C13.4052 11.23 13.5509 11.584 13.5502 12C13.5502 12.4167 13.4042 12.771 13.1122 13.063C12.8202 13.355 12.4662 13.5007 12.0502 13.5ZM11.0002 20H12.9752L13.3252 17.35C13.8419 17.2167 14.3212 17.0207 14.7632 16.762C15.2052 16.5033 15.6092 16.191 15.9752 15.825L18.4502 16.85L19.4252 15.15L17.2752 13.525C17.3585 13.2917 17.4169 13.046 17.4502 12.788C17.4835 12.53 17.5002 12.2673 17.5002 12C17.5002 11.7333 17.4835 11.471 17.4502 11.213C17.4169 10.955 17.3585 10.709 17.2752 10.475L19.4252 8.85L18.4502 7.15L15.9752 8.2C15.6085 7.81667 15.2045 7.496 14.7632 7.238C14.3219 6.98 13.8425 6.784 13.3252 6.65L13.0002 4H11.0252L10.6752 6.65C10.1585 6.78333 9.67953 6.97933 9.2382 7.238C8.79686 7.49667 8.39253 7.809 8.0252 8.175L5.5502 7.15L4.5752 8.85L6.72519 10.45C6.64186 10.7 6.58353 10.95 6.5502 11.2C6.51686 11.45 6.5002 11.7167 6.5002 12C6.5002 12.2667 6.51686 12.525 6.5502 12.775C6.58353 13.025 6.64186 13.275 6.72519 13.525L4.5752 15.15L5.5502 16.85L8.0252 15.8C8.39186 16.1833 8.7962 16.5043 9.2382 16.763C9.6802 17.0217 10.1592 17.2173 10.6752 17.35L11.0002 20Z"
                      fill="white"
                    />
                  </svg>
                </a>
              )}
            </div>
          </div>
          <DataTable
            setShow111={setShow111}
            setUserDel={setUserDel}
            getPrevData={getPrevData}
            getNextData={getNextData}
            currentPage={currentPage}
            pages={pages}
            allRounds={allRounds}
            seteditval={seteditval}
            roundTokenData={roundTokenData}
            roundTokenDataInstitution={roundTokenDataInstitution}
            GetAllRounds={GetAllRounds}
            setShow11={setShow11}
            setShow22={setShow22}
            handleShow33={handleShow33}
            handleShow44={handleShow44}
            ownerAddress={ownerAddress}
            roundTokens={roundTokens}
            roundPrice={currentRoundPrice}
            round={round}
          />
        </div>
      </section>
      <Modal
        className="add-mega-modal global-modal-scss"
        show={show1}
        onHide={handleClose1}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Round</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="add-mega-div">
            <div className="option-field">
              <div className="material-textfield">
                <input
                  type="text"
                  placeholder="Enter Round Name"
                  value={Name}
                  onChange={(e) => {
                    setName(e?.target?.value);
                    let tempErrors = errors;
                    tempErrors["name"] = "";
                    setErrors(errors);
                  }}
                />
                <label>Nick Name</label>
              </div>
            </div>
            <div style={{ position: "unset" }} className="text-danger mb-4">
              <small>{errors.name}</small>
            </div>
            <div className="option-field">
              <div className="material-textfield">
                <input
                  type="number"
                  placeholder="Enter Sale Price in $"
                  value={Price}
                  onChange={(e) => {
                    setPrice(e?.target?.value);
                    let tempErrors = errors;
                    tempErrors["price"] = "";
                    setErrors(errors);
                  }}
                />
                <label>Sale Price</label>
              </div>
            </div>
            <div style={{ position: "unset" }} className="text-danger mb-4">
              <small>{errors.price}</small>
            </div>
            <div className="option-field">
              <h5>Select start time in UTC</h5>
              <div className="material-textfield">
                <input
                  type="datetime-local"
                  placeholder="Starts On"
                  value={Start}
                  onChange={(e) => {
                    setStart(e?.target?.value);
                    let tempErrors = errors;
                    tempErrors["start"] = "";
                    setErrors(errors);
                  }}
                />
                <label>Starts On</label>
              </div>
              <img
                src="\assets\calendar.svg"
                alt="img"
                className="img-fluid calendar-icon"
              />
            </div>
            <div style={{ position: "unset" }} className="text-danger mb-4">
              <small>{errors.start}</small>
            </div>
            <div className="option-field">
              <h5>Select end time in UTC</h5>
              <div className="material-textfield">
                <input
                  type="datetime-local"
                  placeholder="End On"
                  value={EndDate}
                  onChange={(e) => {
                    setEndDate(e?.target?.value);
                    let tempErrors = errors;
                    tempErrors["enddate"] = "";
                    setErrors(errors);
                  }}
                />
                <label>End On</label>
              </div>
              <img
                src="\assets\calendar.svg"
                alt="img"
                className="img-fluid calendar-icon"
              />
            </div>

            <div style={{ position: "unset" }} className="text-danger mb-4">
              <small>{errors.enddate}</small>
            </div>
            {/* <div className="option-field">
                            <div className="material-textfield">
                                <input
                                    type="number"
                                    placeholder="Enter Total Allocation"
                                    value={TotalAlloc}
                                    onChange={(e) => {
                                        setTotalAlloc(e?.target?.value);
                                        let tempErrors = errors;
                                        tempErrors["totalalloc"] = "";
                                        setErrors(errors);
                                    }}
                                />
                                <label>Total Allocation</label>
                            </div>
                        </div> */}
            {/* <div style={{ position: "unset" }} className="text-danger mb-4">
              <small>{errors.totalalloc}</small>
            </div> */}
            {/* <div className="option-field">
              <h5>Select Token(s)</h5>
              <div className="material-textfield"></div>
              <div className="multiselect-custom">
                <Multiselect
                  placeholder=""
                  selectedValues={selectedTokensList?.map((item) => item?.name)}
                  isObject={false}
                  onKeyPressFn={function noRefCheck() {}}
                  onRemove={(selectedList, removedItem) => {
                    const updatedSelectedTokens = selectedTokensList.filter(
                      (token) => token.name !== removedItem
                    );
                    setSelectedTokensList(updatedSelectedTokens);
                    // Additional logic after item removal
                  }}
                  onSearch={function noRefCheck() {}}
                  onSelect={(selectedList, selectedName) => {
                    const selectedToken = tokensList.find(
                      (token) => token.name === selectedName
                    );
                    const updatedSelectedTokens = [
                      ...selectedTokensList,
                      selectedToken,
                    ];

                    setSelectedTokensList(updatedSelectedTokens);
                    // Additional logic after item selection
                  }}
                  customCloseIcon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                    >
                      <path
                        d="M5.14307 12.8571L12.8574 5.14285"
                        stroke="black"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.8574 12.8571L5.14307 5.14285"
                        stroke="black"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  }
                  options={tokensList.map((token) => token?.name)}
                />
              </div>
            </div>
            <div style={{ position: "unset" }} className="text-danger mb-4">
              <small>{errors.tokens}</small>
            </div> */}
            {/* <div className="option-field">
                            <div className="material-textfield">
                                <input
                                    type="text"
                                    placeholder="Enter Amount of DOP Purchased"
                                    value={DOPpur}
                                    onChange={(e) => {
                                        setDOPpur(e?.target?.value);
                                        let tempErrors = errors;
                                        tempErrors["doppur"] = "";
                                        setErrors(errors);
                                    }}
                                />
                                <label>DOP Purchased</label>
                            </div>
                        </div> */}
          </div>
          <div className="twice-btn">
            <button className="btn-cancel" onClick={handleClose1}>
              Back
            </button>
            <button
              className="btn-add"
              disabled={loader}
              onClick={() => {
                CreateRound();
              }}
            >
              {loader ? "Creating..." : "Create"}
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="add-mega-modal global-modal-scss"
        show={show2}
        onHide={handleClose2}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Create Round</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="add-mega-div scuhvscycvst">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="110"
              height="111"
              viewBox="0 0 110 111"
              fill="none"
            >
              <g clip-path="url(#clip0_40_7454)">
                <path
                  d="M33.4785 7.67383H21.522V14.8477H33.4785V7.67383Z"
                  fill="white"
                />
                <path
                  d="M21.522 14.8479H14.3481V22.0217H21.522V14.8479Z"
                  fill="white"
                />
                <path
                  d="M14.3477 22.0217H7.17383V33.9782H14.3477V22.0217Z"
                  fill="white"
                />
                <path
                  d="M14.3477 77.0217H7.17383V88.9782H14.3477V77.0217Z"
                  fill="white"
                />
                <path
                  d="M21.522 88.9783H14.3481V96.1521H21.522V88.9783Z"
                  fill="white"
                />
                <path
                  d="M33.4785 96.1521H21.522V103.326H33.4785V96.1521Z"
                  fill="white"
                />
                <path
                  d="M76.5215 0.5H33.478V7.67385H76.5215V0.5Z"
                  fill="white"
                />
                <path
                  d="M76.5215 103.326H33.478V110.5H76.5215V103.326Z"
                  fill="white"
                />
                <path
                  d="M7.17385 33.9783H0V77.0218H7.17385V33.9783Z"
                  fill="white"
                />
                <path
                  d="M88.4785 7.67383H76.522V14.8477H88.4785V7.67383Z"
                  fill="white"
                />
                <path
                  d="M95.6519 14.8479H88.478V22.0217H95.6519V14.8479Z"
                  fill="white"
                />
                <path
                  d="M102.826 22.0217H95.6519V33.9782H102.826V22.0217Z"
                  fill="white"
                />
                <path
                  d="M102.826 77.0217H95.6519V88.9782H102.826V77.0217Z"
                  fill="white"
                />
                <path
                  d="M95.6519 88.9783H88.478V96.1521H95.6519V88.9783Z"
                  fill="white"
                />
                <path
                  d="M88.4785 96.1521H76.522V103.326H88.4785V96.1521Z"
                  fill="white"
                />
                <path
                  d="M110 33.9783H102.826V77.0218H110V33.9783Z"
                  fill="white"
                />
                <path
                  d="M23.9131 38.7609H16.7393V53.1088H23.9131V38.7609Z"
                  fill="white"
                />
                <path
                  d="M45.4346 38.7609H38.2607V53.1088H45.4346V38.7609Z"
                  fill="white"
                />
                <path
                  d="M38.261 31.587H23.9131V38.7609H38.261V31.587Z"
                  fill="white"
                />
                <path
                  d="M71.7393 38.7609H64.5654V53.1088H71.7393V38.7609Z"
                  fill="white"
                />
                <path
                  d="M93.2608 38.7609H86.0869V53.1088H93.2608V38.7609Z"
                  fill="white"
                />
                <path
                  d="M86.0872 31.587H71.7393V38.7609H86.0872V31.587Z"
                  fill="white"
                />
                <path
                  d="M66.9564 88.9783H43.0435V96.1521H66.9564V88.9783Z"
                  fill="white"
                />
                <path
                  d="M74.1305 60.2827H35.8699H28.6958V67.4565V81.8044H35.8699V67.4565H74.1305V81.8044H81.3046V67.4565V60.2827H74.1305Z"
                  fill="white"
                />
                <path
                  d="M43.0435 81.8044H35.8696V88.9782H43.0435V81.8044Z"
                  fill="white"
                />
                <path
                  d="M74.1304 81.8044H66.9565V88.9782H74.1304V81.8044Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_40_7454">
                  <rect
                    width="110"
                    height="110"
                    fill="white"
                    transform="translate(0 0.5)"
                  />
                </clipPath>
              </defs>
            </svg>
            <h6>New round has been created</h6>
          </div>
          <div className="twice-btn">
            <button
              className="btn-add"
              style={{ flex: "auto" }}
              onClick={handleClose2}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        className="delete-modal global-modal-scss"
        show={show111}
        onHide={handleClose111}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="delete-modal-div">
            <img
              src="\assets\delete-modal-icon.svg"
              alt="img"
              className="img-fluid"
            />
            <h6>Are you sure you want to delete this?</h6>
            <p>This will delete it permanently. You cannot undo this action.</p>
          </div>
          <div className="twice-btn">
            <button onClick={() => handleClose111()} className="btn-cancel">
              Cancel
            </button>
            {account ? (
              <button className="btn-del" onClick={DeleteUser}>
                Delete
              </button>
            ) : (
              <button
                className="btn-del"
                style={{ opacity: "0.5" }}
                onClick={() => connectwalletfirst()}
              >
                Delete
              </button>
            )}
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="add-mega-modal global-modal-scss claiming-modal"
        show={show3}
        onHide={handleClose3}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Round Settings</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="newclaiming-modal">
            <div className="left-side">
              <h6>Private Sale (on/off)</h6>
              <p>This functions turns on or off private sale</p>
            </div>
            <div className="right-side">
              <div className="parent-toggle-switch-custom">
                {account ? (
                  <div class="custom-toggle">
                    <input
                      type="checkbox"
                      class="checkbox"
                      id="checkbox"
                      checked={roundToggleBool}
                      onChange={(e) => {
                        roundToggle(e);
                      }}
                    />
                    <label class="switch" for="checkbox">
                      <span class="slider"></span>
                    </label>
                  </div>
                ) : (
                  <div class="custom-toggle">
                    <input
                      type="checkbox"
                      class="checkbox"
                      id="checkbox"
                      style={{ opacity: "0.5" }}
                      onClick={() => connectwalletfirst()}
                    />
                    <label class="switch" for="checkbox">
                      <span class="slider"></span>
                    </label>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="add-mega-modal global-modal-scss modal-width"
        show={show11}
        onHide={handleClose11}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Round</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="add-mega-div">
            <div className="option-field">
              <div className="material-textfield">
                <input
                  type="number"
                  placeholder="Enter Sale Price"
                  value={Price}
                  onChange={(e) => {
                    setPrice(e?.target?.value);
                    let tempErrors = errors;
                    tempErrors["price"] = "";
                    setErrors(errors);
                  }}
                />
                <label>Sale Price</label>
              </div>
            </div>
            <div style={{ position: "unset" }} className="text-danger mb-4">
              <small>{errors.price}</small>
            </div>
            <div className="option-field">
              <h5>Select start time in UTC</h5>
              <div className="material-textfield">
                <input
                  type="datetime-local"
                  placeholder="Starts On"
                  value={Start}
                  onChange={(e) => {
                    setStart(e?.target?.value);
                    let tempErrors = errors;
                    tempErrors["start"] = "";
                    setErrors(errors);
                  }}
                />
                <label>Starts On</label>
              </div>
              <img
                src="\assets\calendar.svg"
                alt="img"
                className="img-fluid calendar-icon"
              />
            </div>
            <div style={{ position: "unset" }} className="text-danger mb-4">
              <small>{errors.start}</small>
            </div>
            <div className="option-field">
              <h5>Select end time in UTC</h5>
              <div className="material-textfield">
                <input
                  type="datetime-local"
                  placeholder="Enter End On"
                  value={EndDate}
                  onChange={(e) => {
                    setEndDate(e?.target?.value);
                    let tempErrors = errors;
                    tempErrors["enddate"] = "";
                    setErrors(errors);
                  }}
                />
                <label>End On</label>
              </div>
              <img
                src="\assets\calendar.svg"
                alt="img"
                className="img-fluid calendar-icon"
              />
            </div>
            <div style={{ position: "unset" }} className="text-danger mb-4">
              <small>{errors.enddate}</small>
            </div>
            {/* <div className="option-field">
              <h5>Select Token(s)</h5>
              <div className="material-textfield"></div>
              <div className="multiselect-custom cdvtdvtvtvdcvtdvv">
                <Multiselect
                  placeholder=""
                  selectedValues={selectedTokensList?.map((item) => item?.name)}
                  isObject={false}
                  onKeyPressFn={function noRefCheck() {}}
                  onRemove={(selectedList, removedItem) => {
                    const updatedSelectedTokens = selectedTokensList.filter(
                      (token) => token.name !== removedItem
                    );
                    setSelectedTokensList(updatedSelectedTokens);
                    // Additional logic after item removal
                  }}
                  onSearch={function noRefCheck() {}}
                  onSelect={(selectedList, selectedName) => {
                    const selectedToken = tokensList.find(
                      (token) => token.name === selectedName
                    );
                    const updatedSelectedTokens = [
                      ...selectedTokensList,
                      selectedToken,
                    ];

                    setSelectedTokensList(updatedSelectedTokens);
                    setIsOpen(false);

                    // Additional logic after item selection
                  }}
                  customCloseIcon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                    >
                      <path
                        d="M5.14307 12.8571L12.8574 5.14285"
                        stroke="black"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.8574 12.8571L5.14307 5.14285"
                        stroke="black"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  }
                  options={tokensList.map((token) => token?.name)}
                />
              </div>
            </div>
            <div style={{ position: "unset" }} className="text-danger mb-4">
              <small>{errors.tokens}</small>
            </div>
            {selectedTokensList?.length > 0
              ? selectedTokensList?.map((token, index) => {
                  return (
                    <>
                      {token?.name == "ETH" ? (
                        <div className="twice-inputssss">
                          <div className="option-field">
                            <div className="material-textfield">
                              <input
                                type="number"
                                placeholder={`Enter Discounted Price for ${token?.name}`}
                                value={discount[index]}
                                onChange={(e) => {
                                  const input = e.target.value;
                                  const isValidInput =
                                    /^([0-9]+)?(\.[0-9]*)?$/.test(input) &&
                                    parseFloat(input) >= 0;

                                  if (isValidInput || input === "") {
                                    let temp = [...discount];
                                    temp[index] =
                                      input === "" ? "" : parseFloat(input);
                                    setDiscount(temp);
                                  }
                                }}
                              />
                              <label>Discounted Price {token?.name}</label>
                            </div>
                          </div>
                          <div className="option-field">
                            <div className="material-textfield">
                              <input
                                type="number"
                                placeholder={`Normalization Factor For of ${token?.name}`}
                                value={tokenPriceFeed[index]?.[1] || ""}
                                onChange={(e) => {
                                  const input = e.target.value;
                                  const isValidInput =
                                    /^([0-9]+)?(\.[0-9]*)?$/.test(input) &&
                                    parseFloat(input) >= 0;

                                  if (isValidInput || input === "") {
                                    setTokenPriceFeed((prevState) => {
                                      const updatedTokenPriceFeed = [
                                        ...prevState,
                                      ];
                                      updatedTokenPriceFeed[index] = {
                                        ...updatedTokenPriceFeed[index],
                                        1: parseInt(input),
                                      };
                                      return updatedTokenPriceFeed;
                                    });
                                  }
                                }}
                              />
                              <label>
                                Normalization Factor For {token?.name} Token
                              </label>
                            </div>
                          </div>

                          <div className="option-field">
                            <div className="material-textfield">
                              <input
                                type="number"
                                placeholder={`Normalization Factor For ${token?.name} NFT`}
                                value={tokenPriceFeed[index]?.[2] || ""}
                                onChange={(e) => {
                                  const input = e.target.value;
                                  const isValidInput =
                                    /^([0-9]+)?(\.[0-9]*)?$/.test(input) &&
                                    parseFloat(input) >= 0;

                                  if (isValidInput || input === "") {
                                    setTokenPriceFeed((prevState) => {
                                      const updatedTokenPriceFeed = [
                                        ...prevState,
                                      ];
                                      updatedTokenPriceFeed[index] = {
                                        ...updatedTokenPriceFeed[index],
                                        2: parseInt(input),
                                      };
                                      return updatedTokenPriceFeed;
                                    });
                                  }
                                }}
                              />
                              <label>
                                Normalization Factor For {token?.name} NFT
                              </label>
                            </div>
                          </div>
                          <div className="option-field">
                            <div className="material-textfield">
                              <input
                                type="text"
                                placeholder={`Enter Price Feed Address of ${token?.name}`}
                                value={tokenPriceFeed[index]?.[0] || ""}
                                onChange={(e) => {
                                  const input = e.target.value;
                                  setTokenPriceFeed((prevState) => {
                                    const updatedTokenPriceFeed = [
                                      ...prevState,
                                    ];
                                    updatedTokenPriceFeed[index] = {
                                      ...updatedTokenPriceFeed[index],
                                      0: input,
                                    };
                                    return updatedTokenPriceFeed;
                                  });
                                }}
                              />
                              <label>{token?.name} Price Feed Address</label>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="option-field">
                          <div className="material-textfield">
                            <input
                              type="number"
                              placeholder={`Enter Discounted Price for ${token?.name}`}
                              value={discount[index]}
                              onChange={(e) => {
                                const input = e.target.value;
                                const isValidInput =
                                  /^([0-9]+)?(\.[0-9]*)?$/.test(input) &&
                                  parseFloat(input) >= 0;

                                if (isValidInput || input === "") {
                                  let temp = [...discount];
                                  temp[index] =
                                    input === "" ? "" : parseFloat(input);
                                  setDiscount(temp);
                                }
                              }}
                            />
                            <label>Discounted Price {token?.name}</label>
                          </div>
                        </div>
                      )}
                    </>
                  );
                })
              : null} */}
          </div>
          {/* <p
                style={{
                  color: "red",
                  textAlign: "center",
                  marginTop: -15,
                  marginBottom: 15,
                }}
              >
             error
              </p> */}
          <div className="twice-btn">
            <button onClick={() => handleClose11()} className="btn-cancel">
              Back
            </button>
            <button
              className="btn-add"
              onClick={() => {
                EditRound();
              }}
            >
              Edit
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="add-mega-modal global-modal-scss saletokensmodal"
        show={show33}
        onHide={handleClose33}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Sale Tokens</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedTokensList?.length > 0
            ? selectedTokensList?.map((item, index) => {
                return (
                  <>
                    <div className="saletokenmain">
                      <div class="dropdown">
                        <button
                          class="dropdown-toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          {typeof selectedTokensList[index]?.symbol ===
                            "string" && selectedTokensList[index]?.symbol != ""
                            ? selectedTokensList[index]?.symbol
                            : "Select Token"}
                          <img src="\assets\arrowd.svg" alt="img" />
                        </button>
                        <ul class="dropdown-menu">
                          {tokenData?.length > 0
                            ? tokenData?.map((it, ind) => {
                                return (
                                  <>
                                    <li>
                                      <a
                                        class="dropdown-item gscrxcsx"
                                        onClick={() => {
                                          setSelectedTokensList(
                                            (prevTokensList) => {
                                              // Create a shallow copy of the array
                                              const newArr = [
                                                ...prevTokensList,
                                              ];

                                              // Modify the copy
                                              newArr[index] = {
                                                ...newArr[index],
                                                token: it?.address,
                                                symbol: it?.symbol,
                                              };

                                              // Return the modified copy to update the state
                                              return newArr;
                                            }
                                          );
                                        }}
                                      >
                                        {/* <img
                      src="\assets\eth.svg"
                      alt="img"
                      className="img-fluid"
                    /> */}
                                        {it?.symbol}
                                      </a>
                                    </li>
                                  </>
                                );
                              })
                            : null}
                        </ul>
                      </div>
                      <div className="checkboxessmain">
                        <p className="checkboxessmainpara">Discount</p>
                        <div className="checkboxesinner">
                          <div className="checkboxmain">
                            <label className="checkbox" htmlFor={`yes${index}`}>
                              <input
                                type="checkbox"
                                name="color"
                                value="yellow"
                                id={`yes${index}`}
                                checked={discountBoolYes[index]}
                                onChange={(e) => {
                                  let discountBoolYesArr = discountBoolYes;
                                  let discountBoolNoArr = discountBoolNo;
                                  discountBoolYesArr[index] = e.target.checked;
                                  discountBoolNoArr[index] = !e.target.checked;
                                  setDiscountBoolYes([...discountBoolYesArr]); // Make sure to spread the array to create a new reference
                                  setDiscountBoolNo([...discountBoolNoArr]); // Make sure to spread the array to create a new reference
                                }}
                              />
                              <span className="checkmark"></span>
                            </label>
                            <p className="checkboxpara">Yes</p>
                          </div>
                          <div className="checkboxmain">
                            <label className="checkbox" htmlFor={`no${index}`}>
                              <input
                                type="checkbox"
                                name="color"
                                value="yellow"
                                id={`no${index}`}
                                checked={discountBoolNo[index]}
                                onChange={(e) => {
                                  let discountBoolNoArr = discountBoolNo;
                                  let discountBoolYesArr = discountBoolYes;
                                  discountBoolNoArr[index] = e.target.checked;
                                  discountBoolYesArr[index] = !e.target.checked;

                                  setDiscountBoolNo([...discountBoolNoArr]); // Make sure to spread the array to create a new reference
                                  setDiscountBoolYes([...discountBoolYesArr]); // Make sure to spread the array to create a new reference

                                  if (e.target.checked) {
                                    let discountArr = discount;
                                    discountArr[index] = 0;

                                    setDiscount([...discountArr]); // Make sure to spread the array to create a new reference
                                  }
                                }}
                              />
                              <span className="checkmark"></span>
                            </label>
                            <p className="checkboxpara">No</p>
                          </div>
                        </div>
                      </div>
                      {discountBoolYes[index] == true ? (
                        <div className="option-field">
                          <div className="material-textfield">
                            <input
                              type="number"
                              placeholder="Discount Price"
                              value={discount[index]}
                              onChange={(e) => {
                                const input = e.target.value;

                                if (input >= 0) {
                                  let temp = [...discount];
                                  temp[index] =
                                    input === "" ? 0 : parseFloat(input);
                                  setDiscount(temp);
                                }
                              }}
                            />
                            <label>Discounted Price</label>
                            <p className="percentageicon"></p>
                          </div>
                        </div>
                      ) : null}
                    </div>

                    <div className="addremove">
                      <h6
                        className="addremovetexts red"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          let arr = selectedTokensList;
                          let discountArr = discount;
                          const newArray = arr.filter(
                            (_, ind) => ind !== index
                          );
                          const newDiscountArray = discountArr.filter(
                            (_, ind) => ind !== index
                          );

                          setSelectedTokensList(newArray);
                          setDiscount(newDiscountArray);
                        }}
                      >
                        Remove{" "}
                        <img
                          src="\assets\close-circle.svg"
                          alt="removeimg"
                          className="removeimg"
                        />
                      </h6>
                    </div>
                  </>
                );
              })
            : null}

          <div className="addremove">
            <div></div>
            <h6
              className="addremovetexts white"
              style={{ cursor: "pointer" }}
              onClick={() => {
                let arr = selectedTokensList;
                let discountArr = discount;
                let newObj = {
                  access: true,
                  customPrice: 0,
                  symbol: "",
                  token: "",
                };
                let newDiscountArr = [...discountArr, 0];
                let newArr = [...arr, newObj];
                setSelectedTokensList(newArr);
                setDiscount(newDiscountArr);
              }}
            >
              Add Another Token{" "}
              <img
                src="\assets\addcircle.svg"
                alt="removeimg"
                className="removeimg"
              />
            </h6>
          </div>
          <div className="twice-btn">
            <button onClick={handleClose33} className="btn-cancel">
              Back
            </button>
            <button
              className="btn-add"
              onClick={() => {
                editDiscount();
              }}
            >
              Create
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="add-mega-modal global-modal-scss saletokensmodal"
        show={show44}
        onHide={handleClose44}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Sale Tokens Institution</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedTokensListInstitution?.length > 0
            ? selectedTokensListInstitution?.map((item, index) => {
                return (
                  <>
                    <div className="saletokenmain">
                      <div class="dropdown">
                        <button
                          class="dropdown-toggle"
                          type="button"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          {typeof selectedTokensListInstitution[index]
                            ?.symbol === "string" &&
                          selectedTokensListInstitution[index]?.symbol != ""
                            ? selectedTokensListInstitution[index]?.symbol
                            : "Select Token"}
                          <img src="\assets\arrowd.svg" alt="img" />
                        </button>
                        <ul class="dropdown-menu">
                          {tokenData?.length > 0
                            ? tokenData?.map((it, ind) => {
                                return (
                                  <>
                                    <li>
                                      <a
                                        class="dropdown-item gscrxcsx"
                                        onClick={() => {
                                          setSelectedTokensListInstitution(
                                            (prevTokensList) => {
                                              // Create a shallow copy of the array
                                              const newArr = [
                                                ...prevTokensList,
                                              ];

                                              // Modify the copy
                                              newArr[index] = {
                                                ...newArr[index],
                                                token: it?.address,
                                                symbol: it?.symbol,
                                              };

                                              // Return the modified copy to update the state
                                              return newArr;
                                            }
                                          );
                                        }}
                                      >
                                        {/* <img
                      src="\assets\eth.svg"
                      alt="img"
                      className="img-fluid"
                    /> */}
                                        {it?.symbol}
                                      </a>
                                    </li>
                                  </>
                                );
                              })
                            : null}
                        </ul>
                      </div>
                    </div>

                    <div className="addremove">
                      <h6
                        className="addremovetexts red"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          let arr = selectedTokensListInstitution;
                          const newArray = arr.filter(
                            (_, ind) => ind !== index
                          );
                          setSelectedTokensListInstitution(newArray);
                        }}
                      >
                        Remove{" "}
                        <img
                          src="\assets\close-circle.svg"
                          alt="removeimg"
                          className="removeimg"
                        />
                      </h6>
                    </div>
                  </>
                );
              })
            : null}

          <div className="addremove">
            <div></div>
            <h6
              className="addremovetexts white"
              style={{ cursor: "pointer" }}
              onClick={() => {
                let arr = selectedTokensListInstitution;

                let newObj = {
                  access: true,
                  customPrice: 0,
                  symbol: "",
                  token: "",
                };

                let newArr = [...arr, newObj];
                setSelectedTokensListInstitution(newArr);
              }}
            >
              Add Another Token{" "}
              <img
                src="\assets\addcircle.svg"
                alt="removeimg"
                className="removeimg"
              />
            </h6>
          </div>
          <div className="twice-btn">
            <button onClick={handleClose44} className="btn-cancel">
              Back
            </button>
            <button
              className="btn-add"
              onClick={() => {
                allowTokensInstitution();
              }}
            >
              Create
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="add-mega-modal global-modal-scss"
        show={show22}
        onHide={handleClose22}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Round</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="add-mega-div">
            <h6>Round edited successfully</h6>
          </div>
          <div className="twice-btn">
            <button
              onClick={() => handleClose22()}
              className="btn-add"
              style={{ flex: "auto" }}
            >
              Okay
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SalesRound;
